<template>
    <el-form :rules="rules" :model="client" ref="client" label-width="120px">

        <el-form-item label="Kundenklasse">
            <el-select v-model="client.class_id" placeholder="Anrede wählen">
                <el-option label="-" value="0"></el-option>
                <el-option label="A" value="1"></el-option>
                <el-option label="B" value="2"></el-option>
                <el-option label="C" value="3"></el-option>
                <el-option label="D" value="4"></el-option>
                <el-option label="E" value="5"></el-option>
                <el-option label="F" value="6"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Firma">
            <el-input v-model="client.company"></el-input>
        </el-form-item>

        <el-form-item label="Anrede">
            <el-select v-model="client.sex_id">
                <el-option label="Herr" value="1"></el-option>
                <el-option label="Frau" value="2"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Vorname">
            <el-input v-model="client.prename"></el-input>
        </el-form-item>

        <el-form-item label="Name" prop="name">
            <el-input v-model="client.name"></el-input>
        </el-form-item>

        <el-form-item label="Straße und Nr.">
            <el-input v-model="client.street"></el-input>
        </el-form-item>

        <el-form-item label="Zusatz">
            <el-input v-model="client.additional_1"></el-input>
        </el-form-item>

        <el-form-item label="PLZ">
            <el-input v-model="client.zip"></el-input>
        </el-form-item>

        <el-form-item label="Ort">
            <el-input v-model="client.city"></el-input>
        </el-form-item>

        <el-form-item label="Land">
            <el-select v-model="client.country_id" placeholder="Anrede wählen">
                <el-option value="1" label="Deutschland"></el-option>
                <el-option value="2" label="Österreich"></el-option>
                <el-option value="3" label="Schweiz"></el-option>
                <el-option value="4" label="Liechtenstein"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="E-Mail" prop="main_mail">
            <el-input v-model="client.main_mail"></el-input>
        </el-form-item>

        <el-form-item label="Telefonnummer">
            <el-input v-model="client.phone"></el-input>
        </el-form-item>

        <el-form-item label="Mobil">
            <el-input v-model="client.mobile"></el-input>
        </el-form-item>

        <el-form-item label="Umsatzsteuer ID">
            <el-input v-model="client.ust_id"></el-input>
        </el-form-item>

        <div class="text-right">
            <el-button type="success" @click="save()">Kunde anlegen</el-button>
        </div>

    </el-form>

</template>

<script>

import ClientAPI from "~/api/client";

    export default{
        props: {
            offer: Object
        },
        data() {
            return {
                client: {
                    company: "",
                    sex_id: 0,
                    prename: "",
                    name: "",
                    street: "",
                    additional_1: "",
                    additional_2: "",
                    zip: "",
                    city: "",
                    class_id: 4,
                    main_mail: "",
                    phone: "",
                    mobile: "",
                    ust_id: "",
                    country_id: 1,
                    offer_id: 0
                },
                rules: {
                    name: [
                        {required: true, message: 'Bitte einen Namen eingeben', trigger: 'blur'},
                    ],
                    main_mail: [
                        {required: true, message: 'Bitte eine E-Mail Adresse eingeben', trigger: 'blur'}
                    ],
                }
            }
        },
        created() {
            let sex_id = 0;
            let country_id = 0;

            if (this.offer.salutation == "Herr"){
                sex_id = 1;
            }
            else if (this.offer.salutation == "Frau"){
                sex_id = 2;
            }

            if (this.offer.country == "Deutschland"){
                country_id = 1;
            }
            else if (this.offer.country == "Österreich"){
                country_id = 2;
            }
            else if (this.offer.country == "Schweiz"){
                country_id = 3;
            }
            else if (this.offer.country == "Liechtenstein"){
                country_id = 4;
            }


            this.client = {
                company: this.offer.firma,
                sex_id: sex_id,
                prename: this.offer.pre_name,
                name: this.offer.name,
                street: this.offer.street,
                additional_1: "",
                additional_2: "",
                zip: this.offer.zip,
                city: this.offer.city,
                class_id: this.offer.class_id,
                main_mail: this.offer.email,
                phone: this.offer.telefon,
                mobile: "",
                ust_id: "",
                country_id: country_id,
                offer_id: this.offer.id
            }
        },
        methods: {

        save() {
            let that = this;

            this.$refs['client'].validate((valid) => {
                if (valid) {
                    ClientAPI.postAddNewClient({
                        "client": that.client,
                    }).then(function (response) {
                        location.reload();
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
        }
    }
</script>
